import { ChangeEvent } from 'react';

export const formatName = (
	event: ChangeEvent<HTMLInputElement>,
	handleInputChange: (event: ChangeEvent<HTMLInputElement>) => void
) => {
	let { value } = event.target;
	value = value.replace(/[^a-zA-ZáéíóúÁÉÍÓÚñÑ\s]/g, '');

	value = value.replace(/\s{2,}/g, ' ');
	event.target.value = value;
	handleInputChange(event);
};
